import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import queryString from "query-string";

import ProjectList from "../../project/ProjectListPage/ProjectList";
import HeaderWrapper from "../../common/HeaderWrapper";

import { getFilterState } from "../../../utils";

const DashboardProjects = ({
  auth,
  projects,
  dragState,
  isMobile,
  getProjects,
  maxListHeight,
  onPageSizeChange
}) => {
  const [filters, setFilters] = useState({
    page: 0,
    pageSize: 10,
    favorites: auth.user.favorites
  });

  const [sorted, setSorted] = useState(
    getFilterState("PROJECT_SORTED", [{ id: "start_date", desc: false }])
  );

  const [loading, setLoading] = useState(false);

  const history = useHistory();

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const newSorted = sorted.reduce((acc, curr) => {
        acc[`sort.${curr.id}`] = curr.desc ? 1 : -1;
        return acc;
      }, {});
      const query = queryString.stringify(
        {
          ...filters,
          ...newSorted,
          onlyFavorites: true,
          dash: true
        },
        {
          arrayFormat: "bracket"
        }
      );
      await getProjects(`/list?${query}`);
      setLoading(false);
    };
    getData();
  }, [filters, getProjects, sorted]);

  useEffect(() => {
    onPageSizeChange(filters.pageSize, projects.pages, projects.data?.length);
  }, [filters.pageSize, onPageSizeChange, projects]);

  const handleSortedChange = (rtSorted) => {
    setSorted(rtSorted);
  };

  const handlePageSizeChange = (pageSize) => {
    setFilters((prev) => ({ ...prev, pageSize }));
  };

  const handlePageChange = (page) => {
    setFilters((prev) => ({ ...prev, page }));
  };

  const handleRowClick = (rowInfo) => {
    if (!dragState.dragInProcess && dragState.dragOver) {
      history.push(`/app/projects/${rowInfo.original._id}`);
    }
  };

  return (
    <div className="report-page">
      <HeaderWrapper breadcrumbs={[{ label: "My Projects" }]} />
      <ProjectList
        data={projects.data}
        loading={loading}
        sorted={sorted}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        onSortedChange={handleSortedChange}
        page={filters.page}
        pages={projects.pages}
        pageSize={filters.pageSize}
        onRowClick={handleRowClick}
        isMobile={isMobile}
        maxListHeight={maxListHeight}
        isFavoriteToggable={!dragState.dragInProcess && dragState.dragOver}
      />
    </div>
  );
};

export default DashboardProjects;

DashboardProjects.propTypes = {
  auth: PropTypes.object,
  projects: PropTypes.object,
  dragState: PropTypes.object,
  isMobile: PropTypes.bool,
  maxListHeight: PropTypes.string,
  getProjects: PropTypes.func,
  onPageSizeChange: PropTypes.func
};

DashboardProjects.defaultProps = {
  auth: {},
  projects: {},
  dragState: {},
  isMobile: false,
  maxListHeight: "",
  getProjects: () => null,
  onPageSizeChange: () => null
};
